import React from 'react';
import PropTypes from 'prop-types';

function InfoItalic({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        stroke="transparent"
        fill="currentColor"
        d="M14.273 16.977l-.171.703a33.98 33.98 0 01-1.235.465c-.307.106-.664.16-1.07.16-.625 0-1.11-.153-1.457-.457a1.478 1.478 0 01-.52-1.16c0-.183.013-.369.04-.56.025-.19.067-.404.124-.644l.641-2.28c.057-.22.105-.427.145-.622.039-.195.058-.374.058-.535 0-.292-.06-.495-.18-.61-.12-.114-.348-.171-.687-.171-.167 0-.337.026-.512.078a7.004 7.004 0 00-.449.148l.172-.703c.422-.172.825-.319 1.21-.441.386-.123.75-.184 1.095-.184.62 0 1.097.15 1.433.45.336.299.504.688.504 1.167 0 .1-.012.274-.035.524a3.54 3.54 0 01-.129.687l-.64 2.274c-.053.182-.1.39-.141.625a3.327 3.327 0 00-.063.53c0 .303.068.509.203.618.136.11.37.164.704.164.156 0 .333-.027.53-.082.199-.055.342-.103.43-.144zm.165-9.54c0 .396-.15.734-.45 1.012-.3.279-.66.418-1.082.418-.422 0-.784-.14-1.086-.418a1.326 1.326 0 01-.453-1.011c0-.396.151-.735.453-1.016A1.538 1.538 0 0112.906 6c.422 0 .783.14 1.082.422.3.281.45.62.45 1.016z"
      />
    </svg>
  );
}

InfoItalic.propTypes = {
  stroke: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default InfoItalic;
